import React from 'react';
import Chip from '@material-ui/core/Chip';
import Avatar from "@material-ui/core/Avatar";
import Tooltip from '@material-ui/core/Tooltip';

export function udtAvatarType(ut) {
    if ( ut === 'recordType' )
        return 'Rec'
    else if ( ut === 'unionType' )
        return 'Uni'
    else if ( ut === 'keyType' )
        return 'Key'
    else if(  ut === 'traitType' )
        return 'Tra'
    else if ( ut === 'annotationType' )
        return 'Ann'
    else if ( ut === 'entityType' )
        return 'Ent'
    else if ( ut === 'enumType' )
        return 'Enm'
    else if ( ut === 'serviceType' )
        return 'Svc'
    else
        return '?'
}

function FieldDataType( props ) {
    let rootType = props.dtype
    let withAvatar = props.withAvatar
    let udtDetailsComp = props.udtDetailsComp
    let parentNamespace = props.parentNamespace

    return printType(rootType)

    function shortName( name ) {
        if ( parentNamespace.length > 0 && name.startsWith( parentNamespace ) )
            return name.substr(parentNamespace.length + 1, name.length);
        else
            return name;
    }

    function printUdtDataTypeWithIcon(dt) {
        return (
                <Tooltip title={dt.FullyQualifiedName}>
                    <Chip size="small" avatar={<Avatar>{udtAvatarType(dt.UdtType)}</Avatar>} variant="outlined"
                    label={ shortName( dt.FullyQualifiedName ) }
                    onClick={() => { udtDetailsComp.load(dt.FullyQualifiedName) }}
                    //   onMouseEnter={() => { console.log('test') }}
                    //   onMouseLeave={() => { console.log('leave') }}
                    />
                </Tooltip>
               )
    }
    
    function printUdtDataType(dt) {
        return ( <Chip size="small" label={ shortName( dt.FullyQualifiedName) } variant="outlined"
                        onClick={() => { udtDetailsComp.load(dt.FullyQualifiedName) }}  /> 
                )
    }
    
    function printNestedType( name, t ) {
        return (
            <span>
                <span>{name}&lt; </span>
                    { printType(t) }
                <span> &gt;</span>
            </span>
        );
    }
    
    function printType(dt) {
        let tn = dt['@type']
    
        if ( tn === 'alfa.rt.model.EnclosingDataType' ) {
    
        }
        else if ( tn === 'alfa.rt.model.TypeParameterDataType' ) {
    
        }
        else if ( tn === 'alfa.rt.model.OptionalDataType' ) {
            return (
                <span>
                    { printType(dt.ComponentType) }
                    <span><b> ?</b></span>
            </span>
            );
        }
        else if ( tn === 'alfa.rt.model.KeyDataType' ) {
            return printNestedType( 'key', dt.ComponentType)
    
        }
        else if ( tn === 'alfa.rt.model.StreamDataType' ) {
            return printNestedType( 'stream', dt.ComponentType)
        }
        else if ( tn === 'alfa.rt.model.FutureDataType' ) {
            return printNestedType( 'future', dt.ComponentType)
        }
        else if ( tn === 'alfa.rt.model.EncryptedDataType' ) {
            return printNestedType( 'encrypted', dt.ComponentType)
        }
        else if ( tn === 'alfa.rt.model.CompressedDataType' ) {
            return printNestedType( 'compressed', dt.ComponentType)
        }
        else if ( tn === 'alfa.rt.model.TryDataType' ) {
            return printNestedType( 'try', dt.ComponentType)
        }
        else if ( tn === 'alfa.rt.model.TabularDataType' ) {
            return printNestedType( 'table', dt.ComponentType)
        }
        else if ( tn === 'alfa.rt.model.EitherDataType' ) {
            return (
                <span>
                    <span>either&lt; </span>
                    { printType(dt.LeftComponentType) }
                    <span>, </span>
                    { printType(dt.RightComponentType) }
                    <span> &gt;</span>
                </span>
            )
        }
        else if ( tn === 'alfa.rt.model.MapDataType' ) {
            return (
                <span>
                    <span>map&lt; </span>
                    { printType(dt.KeyType) }
                    <span>, </span>
                    { printType(dt.ValueType) }
                    <span> &gt;</span>
                </span>
            )
        }
        else if ( tn === 'alfa.rt.model.TypeDefDataType' ) {
    
        }
        else if ( tn === 'alfa.rt.model.ScalarDataType' ) {
            return printScalar(dt)
        }
        else if ( tn === 'alfa.rt.model.ListDataType' ) {
            return printNestedType( 'list', dt.ComponentType)
    
        }
        else if ( tn === 'alfa.rt.model.SetDataType' ) {
            return printNestedType( 'set', dt.ComponentType)
        }
    
        else if ( tn === 'alfa.rt.model.EnumDataType' ) {
            return (
                <span>
                    <span>enum&lt; </span>
                    { dt.Fields.map( (ele,index) => <span key={index}>{ele} </span>) }
                    <span> &gt;</span>
                </span>
            )
        }
        else if ( tn === 'alfa.rt.model.TupleDataType' ) {
            return (
                <span>
                    <span>tuple&lt; </span>
                    { Object.keys(dt.Fields).map( (k,index) =>
                        (
                            <span key={index}>
                                {index>0? <span>, </span> : <span></span>}
                                {dt.SyntheticFieldNames? <span></span> : <span>{dt.Fields[k].Name}<b> : </b></span>}
                                <span><FieldDataType parentNamespace={parentNamespace} dtype={dt.Fields[k].DataType}/></span>
                            </span>
    
                        ))}
                    <span> &gt;</span>
                </span>
            )
        }
        else if ( tn === 'alfa.rt.model.TypeOfDataType' ) {
    
        }
        else if ( tn === 'alfa.rt.model.UnionDataType' ) {
            return (
                <span>
                    <span>union&lt; </span>
                    { Object.keys(dt.Fields).map( (k,index) =>
                        (
                            <span key={index}>
                                {index>0? <span>, </span> : <span></span>}
                                {dt.SyntheticFieldNames? <span></span> : <span>{dt.Fields[k].Name}<b> : </b></span>}
                                <span><FieldDataType parentNamespace={parentNamespace} dtype={dt.Fields[k].DataType}/></span>
                            </span>
    
                        ))}
                    <span> &gt;</span>
                </span>
            )
        }
        else if ( tn === 'alfa.rt.model.UdtDataType' ) {
            if ( withAvatar )
                return printUdtDataTypeWithIcon(dt)
            else
                return printUdtDataType(dt)

        }

        else if ( tn === 'alfa.rt.model.UdtVersionedName') {
            if ( withAvatar )
                return printUdtDataTypeWithIcon(dt)
            else
                return printUdtDataType(dt)
        }

        else {
            return "unhandled datatype " + String(dt);
        }
    
        return (
            "unhandled " + tn
        );
    }
    
    function printScalar(dt) {
        let st = dt.ScalarType
        return st.replace("Type", "")
    }
}

export default FieldDataType;
